import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, Hidden, Typography } from '@material-ui/core';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

import { ReactComponent as DownloadIcon } from '../../../assets/img/icon/Download.svg';
import WhatsappDialog from '../../../components/CommonDialogs/WhatsappDialog.component';
import SubHeader from '../../../components/Header/SubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import { appConfig } from '../../../config/app';
import { CustomEvents } from '../../../constants/analytics.constant';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import useLogEventInAnalytics from '../../../hooks/useLogAnalyticsEvent';
import { useTipification } from '../../../hooks/useTipification';
import Terms from './Terms.component';
import VehicleDetails from './VehicleDetails.component';

const CirculationCardDetails = () => {
  const { loading } = useVehiclesContext();
  const { user } = useAuthDataContext();
  const { logEvent } = useLogEventInAnalytics();
  const { vehicle } = useVehiclesContext();
  const { trackEvent, events } = useTipification();

  useEffect(() => {
    logEvent(CustomEvents.CIRCULATION_CARD_VIEW, {
      app: appConfig?.NAME,
    });
  }, [logEvent]);

  useEffect(() => {
    dataLayerPush('Inicio_tarjeta_circulacion', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadCirculationCard = async () => {
    const input = document.getElementById('circulation-card');
    try {
      const canvas = await html2canvas(input);
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const pdfWidth = pdf.internal.pageSize.getWidth();
      // const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(
        `Tarjeta_de_circulación_${vehicle.brand}_${
          vehicle.model.split(' ')[0]
        }.pdf`
      );
      trackEvent(events.DOCUMENTATION_SEND_CIRCULATION_CARD);
    } catch (error) {
      setOpenWhatsappDialog(true);
    }
  };

  const [open_dialog, setOpenWhatsappDialog] = useState(false);

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando vehículo'}></Loader>
      </Box>

      <WhatsappDialog
        is_open={open_dialog}
        close_dialog={() => setOpenWhatsappDialog(false)}
        message={`Ocurrió un error al descargar tu tarjeta de circulación. Intentalo más tarde o podés seguir operando vía Whatsapp.`}
      />

      <SubHeader
        content={
          <Typography variant="h6" color="primary">
            Tarjeta de circulación
          </Typography>
        }
        actions={
          <Button color="secondary" onClick={() => downloadCirculationCard()}>
            {/* <Button color="secondary" onClick={() => window.print()}> */}
            <DownloadIcon />{' '}
            <Hidden smDown>
              {' '}
              <Box ml={1} style={{ color: '#FA6400' }}>
                Descargar tarjeta
              </Box>
            </Hidden>
          </Button>
        }
      ></SubHeader>
      <Grid
        container
        justify="center"
        alignItems="center"
        id="circulation-card"
      >
        <Grid item xs={11} lg={9} xl={8}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} sm={8} md={6}>
              <Box my={3}>
                <VehicleDetails></VehicleDetails>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Terms></Terms>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CirculationCardDetails;
